import { sharedTheming } from 'shared/sharedTheming';

export const Theming = {
    ...sharedTheming,
    primaryBackgroundColor: '#FFF',
    headerBackgroundColor: 'transparent',
};
